import GenericModel from '../generic-model';

export class StockLocation extends GenericModel {
  rack: number;
  shelf: string;
  compartment: number;
}
